import React from 'react';
import {
    makeStyles,
    Theme,
    useTheme,
} from '@material-ui/core';
import { TextField } from '../../../components/TextField';
import { FormGroup } from '../../../components/FormGroup';

export type GuestContactFormData = {
    partnerUserId: string,
    customerVat: string,
    customerDepartmentId: string,
    address: string,
    contactId: string,
    contactPhone: string,
    contactEmail: string,
};

type GuestContactFormProps = {
    data: GuestContactFormData,
    onChange: (data: GuestContactFormData) => void,
};

GuestContactForm.defaultProps = {

};

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
    },
    title: {
        color: theme.palette.mainColor,
    },
}));

function GuestContactForm(props: GuestContactFormProps): React.ReactElement {
    const {
        data,
        onChange,
    } = props;
    const classes = useStyles();
    const theme = useTheme();

    return (
        <FormGroup title="聯絡資料">
            <TextField
                label="公司/學校系所"
                value={data.partnerUserId}
                onChange={(e) => onChange({
                    ...data,
                    partnerUserId: e.target.value,
                })}
                required
            />
            <TextField
                label="公司/學校統編"
                value={data.customerVat}
                onChange={(e) => onChange({
                    ...data,
                    customerVat: e.target.value,
                })}
            />
            <TextField
                label="部門單位/老師實驗室"
                value={data.customerDepartmentId}
                onChange={(e) => onChange({
                    ...data,
                    customerDepartmentId: e.target.value,
                })}
                required
            />
            <TextField
                label="取件地點"
                value={data.address}
                onChange={(e) => onChange({
                    ...data,
                    address: e.target.value,
                })}
            />
            <TextField
                label="姓名"
                value={data.contactId}
                onChange={(e) => onChange({
                    ...data,
                    contactId: e.target.value,
                })}
                required
            />
            <TextField
                label="電話/手機"
                value={data.contactPhone}
                onChange={(e) => onChange({
                    ...data,
                    contactPhone: e.target.value,
                })}
                required
            />
            <TextField
                label="E-mail"
                value={data.contactEmail}
                onChange={(e) => onChange({
                    ...data,
                    contactEmail: e.target.value,
                })}
                required
            />
        </FormGroup>
    );
}

export { GuestContactForm };
